import React, {useEffect} from "react";

/// React router dom
import { Router, Switch, Route } from "react-router-dom";
import {useHistory, useLocation} from "react-router";

/// Css
import "./mainChart.css";
import "./mainIndex.css";

/// Layout
import Nav from "./Navigation/layouts/nav";
import Footer from "./Navigation/layouts/Footer";


import clsx from "clsx";


/// Deshboard
import Home from "./Home"
import Exams from "./Exams/Exams";
import RevisionCCQCM from "./Exams/RevisionCCQCM";
import {useDispatch} from "react-redux";
import {launchTest} from "../redux/actions/actions";
import MultiSelect from "./MultiSelect/MultiSelect";
import AfterRegistartion from "./AfterRegistration/AfterRegistration";
import Registration from "./Registration/Registration";
import Payment from "./Payment/Payment";
import ExamenCCQCM from "./Exams/ExamenCCQCM";
import GeneralHistoriques from "./Historiques/GeneralHistoriques";
import Examen from "./Exams/Examen";
import Error404 from "../ErrorsPages/Error404";
import Revision from "./Exams/Revision";
import Login from "./Login/Login";



const Main = () => {
    let routeLocation = useLocation();
    let history=useHistory();
    let pathName = routeLocation.pathname;
    const dispatch = useDispatch();
    useEffect(()=>{
            history.listen((location,action)=>{
                console.log('ROUTE CHANGED !');
            });
            dispatch(launchTest());
    }, []);
    const routes = [
        /// Deshborad
        {url : "" , component: <Home/>},
        { url: "dashboard", component: <Home/> },
        {url : "revision/:quizId" , component:
                <React.Fragment>
                    <Revision/>
                </React.Fragment>

        },
        {url : "revision" , component: <RevisionCCQCM/>},
        {url : 'examen' , component: <ExamenCCQCM/>},
        {url : 'examen2' , component: <Examen/>},
        {url : 'multiselect' , component: <MultiSelect/>},
        {url : 'after-registration' , component: <AfterRegistartion/>},
        {url : 'registration' , component: <Registration/>},
        {url : 'payment' , component: <Payment/>},
        {url : 'general-historiques' , component: <GeneralHistoriques/>},
        {url : 'login' , component: <Login/>}
    ];
    const pathsWithoutSideBar=['examen' , '/registration' , '/payment' , 'revision' , '/login'];
    const pathsWithoutContainerFluid = ['/payment' , 'multiselect' , '/multiselect2'];
    let showSideBar=true;
    let addConatinerFluidClass=true;
    pathsWithoutSideBar.forEach(path=>{
        if(pathName.includes(path)){
            showSideBar=false;
        }
    });
    pathsWithoutContainerFluid.forEach(path=>{
        if(pathName.includes(path)){
            addConatinerFluidClass=false;
        }
    })
    return (
        <Router history={history}>
            <div id="main-wrapper" className="show">
                <Nav pathName={pathName} />
                <div className={clsx({ 'content-body' : showSideBar })}>
                    <div className={clsx({ 'container-fluid' : addConatinerFluidClass })}>
                        <Switch>
                            {routes.map((data, i) => (
                                <Route
                                    key={i}
                                    exact
                                    path={`/${data.url}`}
                                >
                                    {data.component}
                                </Route>
                            ))}
                            <Route path="*" component={() => <Error404 />} />
                        </Switch>
                    </div>
                </div>

                {/*<Footer pathName={pathName}/>*/}
            </div>
        </Router>
    );
};

export default Main;
